// Tiny in-app navigation guard. A page with unsaved/in-progress work registers a handler; the Navbar asks it before
// navigating. The handler receives `proceed` (call it to leave). Only one guard is active at a time.
let guard = null;
export const setNavGuard = (fn) => { guard = fn; };
export const clearNavGuard = (fn) => { if (!fn || guard === fn) guard = null; };
export const hasNavGuard = () => Boolean(guard);
// Returns true when navigation was intercepted (caller must NOT navigate); false when it's fine to go.
export const interceptNav = (proceed) => { if (!guard) return false; guard(proceed); return true; };
